import { Switch } from '@/components/ui/switch';
import Ionicons from '@expo/vector-icons/Ionicons';
import React from 'react';
import { Text, View } from 'react-native';
import { SettingsToggleItemData } from './settings-item';

interface SettingsToggleItemProps {
  item: SettingsToggleItemData;
  isLast?: boolean;
}

export function SettingsToggleItem({
  item,
  isLast = false,
}: SettingsToggleItemProps) {
  return (
    <View
      className={`flex-row items-center py-4 ${!isLast ? 'border-b border-border' : ''}`}
      style={{
        opacity: item.disabled ? 0.4 : 1,
      }}
    >
      <View className="w-8 items-center mr-3">
        <Ionicons
          name={item.icon as any}
          size={22}
          className={item.disabled ? 'text-muted-foreground' : 'text-foreground'}
        />
      </View>
      <Text
        className={`flex-1 text-base ${item.disabled ? 'text-muted-foreground' : 'text-foreground'}`}
      >
        {item.title}
      </Text>
      <Switch
        value={item.value}
        onValueChange={item.onToggle}
        disabled={item.disabled}
      />
    </View>
  );
}
